<div class="reports-container">

  <div class="reports-header">
    <h2 class="reports-title">Incomplete Wills Report</h2>
    <button mat-raised-button class="download-btn" (click)="downloadCsv()">
      <mat-icon>download</mat-icon> Download Report
    </button>
  </div>

  <div class="filter-container">

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Probate ID</mat-label>
      <input matInput [(ngModel)]="probateIdSearch" placeholder="Enter Probate ID..."
             [disabled]="nameSearch.trim().length > 0"
             (keyup.enter)="applyFilters()">
      <button *ngIf="probateIdSearch" matSuffix mat-icon-button (click)="probateIdSearch = ''; applyFilters()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-field search-field--wide">
      <mat-label>Deceased Name</mat-label>
      <input matInput [(ngModel)]="nameSearch" placeholder="Enter deceased name..."
             [disabled]="probateIdSearch.trim().length > 0"
             (keyup.enter)="applyFilters()">
      <button *ngIf="nameSearch" matSuffix mat-icon-button (click)="nameSearch = ''; applyFilters()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <button mat-raised-button class="search-btn"
            (click)="applyFilters()"
            [disabled]="!probateIdSearch.trim() && !nameSearch.trim()">Search</button>

    <button mat-button class="clear-btn"
            *ngIf="probateIdSearch || nameSearch"
            (click)="clearSearch()">Clear</button>

    <span class="spacer"></span>

    <span class="results-count">{{ dataSource.data.length }} record(s) found</span>

    <mat-paginator #paginator
                   [pageSize]="pageSize"
                   [pageSizeOptions]="[50, 100, 200, 500]"
                   (page)="pageChanged($event)"
                   showFirstLastButtons>
    </mat-paginator>

  </div>

  <!-- Table -->
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 reports-table">

    <ng-container matColumnDef="probateId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Probate ID</th>
      <td mat-cell *matCellDef="let row">{{ row.probateId }}</td>
    </ng-container>

    <ng-container matColumnDef="deceasedName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Deceased Name</th>
      <td mat-cell *matCellDef="let row">{{ row.deceasedName }}</td>
    </ng-container>

    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>File Name</th>
      <td mat-cell *matCellDef="let row">{{ row.fileName }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">No incomplete wills found.</td>
    </tr>
  </table>

</div>
